var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"talk"},[(!_vm.type)?_c('el-button',{attrs:{"type":"primary","size":_vm.size,"round":""},on:{"click":_vm.toHerf}},[_vm._v("立即沟通")]):_c('span',{on:{"click":_vm.toHerf}},[_vm._t("btn")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }